import { render, staticRenderFns } from "./orderSearch.vue?vue&type=template&id=6605b3e8&scoped=true&"
import script from "./orderSearch.vue?vue&type=script&lang=js&"
export * from "./orderSearch.vue?vue&type=script&lang=js&"
import style0 from "./orderSearch.vue?vue&type=style&index=0&id=6605b3e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6605b3e8",
  null
  
)

export default component.exports